import { createTheme } from "@mui/material/styles";

export const myTheme = createTheme({
  palette: {
    primary: {
      main: "#0558D7",
    },
  },
  typography: {
    fontFamily: [
      '"Helvetica Neue"',
      "Arial",
      '"Hiragino Kaku Gothic ProN"',
      '"Hiragino Sans"',
      '"BIZ UDPGothic"',
      "Meiryo",
      "sans-serif",
    ].join(","),
  },
});
